import { render, staticRenderFns } from "./Account4CRUD.vue?vue&type=template&id=569cfd67"
import script from "./Account4CRUD.vue?vue&type=script&lang=js"
export * from "./Account4CRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports